module.exports = __webpack_public_path__ + "static/media/4850.e3762532.jpg";